module.exports = __webpack_public_path__ + "static/media/LandingPageBannerforNISM.a37a7d5b.png";